import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import environment from 'environments';
import storageService from 'app/core/services/storageService';
import modalService from 'app/core/services/modalService';
import { StorageKeysEnum } from 'app/core/enums/storage';
import store from 'app/store';
import { setAsyncSpinnerVisibleAction } from 'app/store/ui/actions';
import { routerHistory } from 'app/core/router/service';
import { ROUTES } from 'app/core/router/paths';

/**
 * @description 全局設定 AJAX Request 攔截器 (interceptor)
 */
axios.interceptors.request.use(
  function (config: AxiosRequestConfig) {
    const authorizationState = store.getState().common.member.authorization; // 取得登入授權資料
    config.baseURL = `${environment.backend.domainName}${environment.backend.api.port}${environment.backend.api.url.prefix}`;
    config.headers = { ...config.headers };
    config.headers.ApplicationId = environment.application.id;
    config.headers.SessionId = storageService.getItem(StorageKeysEnum.SessionId);
    if (authorizationState) {
      config.headers.Token = `${environment.backend.api.headers.authorization.prefix} ${authorizationState.token}`;
    }
    if (authorizationState?.refreshToken) {
      config.headers.refreshToken = `${environment.backend.api.headers.authorization.prefix} ${authorizationState.refreshToken}`;
    }
    config.headers.Authorization = `${environment.backend.api.headers.authorization.prefix} ${environment.backend.api.headers.authorization.code}`;
    store.dispatch(setAsyncSpinnerVisibleAction(true));
    return config;
  },
  function (error) {
    store.dispatch(setAsyncSpinnerVisibleAction(false));
    return Promise.reject(error);
  }
);

/**
 * @description 全局設定 AJAX Response 攔截器 (interceptor)
 */
axios.interceptors.response.use(
  function (response: AxiosResponse) {
    store.dispatch(setAsyncSpinnerVisibleAction(false));
    return response;
  },
  function (error) {
    store.dispatch(setAsyncSpinnerVisibleAction(false));
    if (error.response) {
      switch (error.response.status) {
        case 401:
          modalService.base('系統提醒', '未經授權，請重新登入。');
          break;
        case 404:
          routerHistory.push(ROUTES.PAGE_ERROR_404);
          break;
        case 500:
          routerHistory.push(ROUTES.PAGE_ERROR_500);
          break;
        default:
          modalService.base('系統提醒', '系統發生錯誤，請洽資訊人員處理。');
          break;
      }
    }
    return Promise.reject(error);
  }
);
